import React, { Component, Fragment } from 'react';
import axios from 'axios'

import withStyles from '@mui/styles/withStyles';
import Alert from '@mui/material/Alert';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import Loading from '../helper/Loading';
import Error from '../helper/Error';
import SimpleTable from '../helper/SimpleTable';
import DeleteDialog from '../helper/Dialogs';

import { authContext } from "../../context/AuthContext";

class ContactTemplates extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);

        this.state = {
            templates: [],
            error: null,
            id: null,
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            isDeleteDialogOpen: false,
            itemToDelete: ''
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    onNew = (event) => {
        this.props.history.push('/administration/contactTemplate');
    }

    onEdit = (tag) => {
        let id = tag;
        this.props.history.push('/administration/contactTemplate/' + id);
    }

    openDeleteDialog = (tag) => {
        this.setState({ itemToDelete: tag });
        this.handleDeleteDialogOpen();
    }

    onDelete = (event) => {
        // let id = event.currentTarget.getAttribute('data-tag');
        this.handleDeleteDialogClose();
        let id = this.state.itemToDelete;
        this.setState({ itemToDelete: '' });
        let url = "/api/contactTemplate/" + id;
        let token = sessionStorage.getItem('accessToken');

        axios(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {
            if (response.status === 200) {
                this.refresh();
            }
        });
    }

    refresh() {
        axios.get('/api/contactTemplate', {
        }).then((res) => {
            this.setState({
                templates: res.data.templates
            }
            );
        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                error: error.message
            });
        });
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    componentDidMount() {
        this.refresh();
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    render() {
        const { classes } = this.props;
        const enableActions = this.context.roles.isClassroomTrainingAdmin === 1? true:false;

        if (this.state.error) {
            return <div>
                <br />
                <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                <br />
            </div>
        }

        if (this.state.error !== null) return <Error />;

        if (this.state.templates.length === 0) return <Loading />;

        let enhancedData = [];
        enhancedData = this.state.templates.map((arrayItem) => {
            let item = JSON.parse(JSON.stringify(arrayItem));
            item.name = item.firstName + ' ' + item.lastName
            item.actionsDisabled = {
                edit: false,
                delete: false
            }
            return item;
        });

        const tableCells = [
            { id: 'name', label: 'Name', centered: false },
            { id: 'email', label: 'Email', centered: false },
            { id: 'phone', label: 'Phone Number', centered: false },

            
        ];

        const actionButtons = [
            { icon: "edit", action: this.onEdit, disabled: false, delete: false },
            { icon: "delete", action: this.openDeleteDialog, disabled: false, delete: true }
        ];

        return (
            <Fragment>
                <PageHeader
                    title={"Templates - Contact"}
                    actionButtons={[{ label: "Add New Contact", action: this.onNew, disabled: enableActions === false }]}
                />

                <div>
                    <div className={classes.root}>
                        <div>
                            <br />

                            <SimpleTable
                                data={enhancedData}
                                cellKey={"ID"}
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={enableActions}
                            />
                            <DeleteDialog
                                open={this.state.isDeleteDialogOpen}
                                onClose={this.handleDeleteDialogClose}
                                onDelete={this.onDelete}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

// export default ContactTemplates;
export default withStyles(styles, { withTheme: true })(ContactTemplates);
